import React, { useState } from 'react';
import { Box, PalletDimensions } from '../types';
import { FileUpload } from './FileUpload';

interface BoxInputProps {
  onAddBox: (box: Box) => void;
  onAddBoxes: (boxes: Box[]) => void;
  palletDimensions: PalletDimensions;
}

export const BoxInput: React.FC<BoxInputProps> = ({ onAddBox, onAddBoxes, palletDimensions }) => {
  const [formData, setFormData] = useState({
    asin: '',
    length: '',
    width: '',
    height: '',
    quantity: ''
  });
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const length = parseFloat(formData.length);
    const width = parseFloat(formData.width);
    const height = parseFloat(formData.height);
    const quantity = parseInt(formData.quantity);

    if (
      !(
        (
          length <= palletDimensions.length && width <= palletDimensions.width
        ) ||
        (
          length <= palletDimensions.width && width <= palletDimensions.length
        )
      ) ||
      height > palletDimensions.maxHeight
    ) {
      setError(
        `Box length and width must fit within the pallet dimensions (${palletDimensions.length} × ${palletDimensions.width} cm) in either orientation, and height ≤ ${palletDimensions.maxHeight} cm.`
      );
      return;
    }

    setError(null);
    const box: Box = {
      id: Date.now().toString(),
      length,
      width,
      height,
      quantity,
      asin: formData.asin || undefined
    };
    onAddBox(box);
    setFormData({ asin: '', length: '', width: '', height: '', quantity: '' });
  };

  return (
    <div>
      <FileUpload onAddBoxes={onAddBoxes} />

      {/* OR Separator */}
      <div className="flex items-center my-6">
        <div className="flex-grow border-t border-gray-200"></div>
        <span className="mx-4 text-gray-400 font-semibold">or</span>
        <div className="flex-grow border-t border-gray-200"></div>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6">Add Box Type</h2>
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          {error && (
            <div className="bg-red-100 text-red-700 rounded-md px-4 py-2 mb-2 text-sm">
              {error}
            </div>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
                  <label htmlFor="length" className="block text-sm font-medium text-gray-700 mb-1">
                    Length (cm)
                  </label>
            <input
              type="number"
                    id="length"
                    value={formData.length}
                    onChange={(e) => setFormData({ ...formData, length: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="30"
                    min="1"
              required
            />
          </div>
          <div>
                  <label htmlFor="width" className="block text-sm font-medium text-gray-700 mb-1">
                    Width (cm)
                  </label>
            <input
              type="number"
                    id="width"
                    value={formData.width}
                    onChange={(e) => setFormData({ ...formData, width: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="20"
                    min="1"
              required
            />
          </div>
                <div>
                  <label htmlFor="height" className="block text-sm font-medium text-gray-700 mb-1">
                    Height (cm)
                  </label>
                  <input
                    type="number"
                    id="height"
                    value={formData.height}
                    onChange={(e) => setFormData({ ...formData, height: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="15"
                    min="1"
                    required
                  />
        </div>
          <div>
                  <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-1">
                    Quantity
                  </label>
            <input
              type="number"
                    id="quantity"
                    value={formData.quantity}
                    onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="10"
                    min="1"
              required
            />
          </div>
              </div>

          <div>
            <label htmlFor="asin" className="block text-sm font-medium text-gray-700 mb-1">
              Product ID (Optional)
            </label>
            <input
              type="text"
              id="asin"
              value={formData.asin}
              onChange={(e) => setFormData({ ...formData, asin: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="B08N5WRWNW"
            />
            <p className="text-xs text-gray-500 mt-1">
              Enter a product identifier for tracking (e.g., SKU, ASIN, UPC)
            </p>
          </div>
          
        <button
          type="submit"
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 font-medium"
        >
          Add Box Type
        </button>
      </form>
      </div>
    </div>
  );
}; 